import { z } from "zod";
import { isoDate } from "./common.js";

/** VaultSage Chat V2 randomness (0 = deterministic, 2 = maximum). */
export const llmTemperatureSchema = z.number().min(0).max(2);

/** VaultSage Chat V2 nucleus sampling (0–1). */
export const llmTopPSchema = z.number().min(0).max(1);

/** Optional provider seed; non-negative integer. */
export const llmSeedSchema = z.number().int().min(0);

/**
 * Platform-wide sampling parameters forwarded on every VaultSage chat call.
 * Deterministic defaults keep identical prompts producing identical answers.
 */
export const llmSettingsSchema = z.object({
  temperature: llmTemperatureSchema,
  topP: llmTopPSchema,
  seed: llmSeedSchema,
  updatedAt: isoDate,
});
export type LlmSettings = z.infer<typeof llmSettingsSchema>;

/**
 * Every field is optional so a Super Admin can change one parameter without
 * re-sending the others, but an empty body is rejected rather than silently
 * recorded as an update that changed nothing.
 */
export const updateLlmSettingsSchema = z
  .object({
    temperature: llmTemperatureSchema.optional(),
    topP: llmTopPSchema.optional(),
    seed: llmSeedSchema.optional(),
  })
  .refine((value) => Object.values(value).some((field) => field !== undefined), {
    message: "Provide at least one field to update.",
  });
export type UpdateLlmSettingsInput = z.infer<typeof updateLlmSettingsSchema>;

/** Built-in deterministic defaults used when the singleton row is first created. */
export const DEFAULT_LLM_SETTINGS = {
  temperature: 0,
  topP: 1,
  seed: 0,
} as const;
